const AudioPlayOption = require('AudioPlayOption');

cc.Class({
    extends: cc.Component,

    properties: {
        audioSprite: {
            type: cc.AudioClip,
            default: null
        },
        audioSpriteJson: {
            type: cc.JsonAsset,
            default: null
        },
        woosh: {
            default: 'woosh'
        },
        reelStop: {
            default: 'reelStop'
        },
        reelLoop: {
            default: 'reelLoop'
        },
        coinsLoop: {
            default: 'coinLoop'
        },
        anticipation: {
            default: 'anticipation'
        },
        mainMusic: {
            default: 'mainMusic'
        },
        uiButton: {
            default: 'Button 1'
        },
        uiBetDecrease: {
            default: 'Button 1'
        },
        uiBetIncrease: {
            default: 'introBetIncrease'
        },
        introBetButton: AudioPlayOption,

    },

    onLoad () {
        cc.game.addPersistRootNode(this.node);

        this.audio = cc.find('AudioManager').getComponent(require('AudioManager'));
    },

    playMusic (spriteName, track = 0, loop = true, cb = null) {
        return this.audio.playMusicSprite(this.audio.audioSprite, track, spriteName, loop, cb);
    },

    playOneShot (spriteName) {
        return this.audio.playOneShotSprite(this.audio.audioSprite, spriteName);
    },

    playSfx (spriteName, count = 1) {
        return this.audio.playSfxSprite(this.audio.audioSprite, spriteName, count);
    },

    playWinMatchSfx(type) {
        let sound = 'winMatch';
        let delay = 0;

        switch(type) {
            case 'H1':
                sound += 'Oddin';
                delay = .8;
            break;
            case 'H2':
                sound += "Frea";
                delay = .6;
            break;
            case 'H3':
                sound += 'Thor';
                delay = .6;
            break;
            case 'H4':
                sound += 'Fox';
            break;
            case 'H5':
                sound += 'Tramp';
                delay = .5;
            break;
            default:
                sound +=  "";
            break;
        }

        this.scheduleOnce(() => {
            this.playOneShot(sound);
        }, delay);
    }
});
